import { mutatorAction } from 'satcheljs';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import getCalendarPickerStore from '../selectors/getCalendarPickerStore';

export const collapseAccount = mutatorAction(
    'collapseAccount',
    (scenarioId: CalendarPickerScenarioId, userIdentity: string) => {
        getCalendarPickerStore(scenarioId).collapsedCalendarAccounts.set(userIdentity, true);
    }
);

export const expandAccount = mutatorAction(
    'expandAccount',
    (scenarioId: CalendarPickerScenarioId, userIdentity: string) => {
        getCalendarPickerStore(scenarioId).collapsedCalendarAccounts.delete(userIdentity);
    }
);

export const toggleCalendarAccount = mutatorAction(
    'toggleCalendarAccount',
    (scenarioId: CalendarPickerScenarioId, userIdentity: string) => {
        if (userIdentity) {
            const store = getCalendarPickerStore(scenarioId);

            if (store.collapsedCalendarAccounts.has(userIdentity)) {
                store.collapsedCalendarAccounts.delete(userIdentity);
            } else {
                store.collapsedCalendarAccounts.set(userIdentity, true);
            }
        }
    }
);
